/* eslint-disable */
"use strict";
import configurazioni from "@/services/configurazioniService.js";
import { fetchTO } from "@/components/helpers";
// const service = process.env.VUE_APP_service_fidelity || '' // usato solo per installazione su Windows 32bit (senza IIS con reverse proxy)
var config, service;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_fidelity || process.env.VUE_APP_service_fidelity;
})();

async function cicleSync(multiplo) {
  try {
    const response = await fetch(`${service}/cicleSync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ multiplo }),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getRunMode() {
  try {
    const response = await fetchTO(`${service}/mode`);
    const result = await response.json();
    if (result.status === 404) {
      return defaultRunMode();
    }
    return result;
  } catch {
    return defaultRunMode();
  }
}

function defaultRunMode() {
  return {
    modulo: "FIDELITY",
    locale: "---",
    remote: "---",
    versione: "---",
    health: "---",
  };
}

async function getFidelity(barcode) {
  if (!barcode) {
    return;
  }
  const response = await fetch(`${service}/${barcode}`);
  return await response.json();
}

/*async function creaBuonoMultiuso(idCassa, importo) {
  var barcode = await configurazioni.getBarcodeInfo("buonomultiuso");
  const data = {
    prefisso: `${barcode.prefisso}${String(idCassa).padStart(2, "0")}`,
    ultimoNumero: barcode.ultimoNumero,
    tipo: barcode.tipoCodice,
    importo,
  };
  const response = await fetch(`${service}/create/buono`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  // La funzione restituisce errore se il buono da creare esiste già --> ciclo per creare il successivo, fino a quando non viene trovato
  const buonoCreato = await response.json();
  debugger
  if (buonoCreato.status === 'error') {
  }
  await configurazioni.setBarcodeInfo(
    "buonomultiuso",
    "write",
    buonoCreato.ultimoNumero,
  );
  return buonoCreato;
}*/

async function creaBuonoMultiuso(idCassa, importo) {
  var barcode = await configurazioni.getBarcodeInfo("buonomultiuso");
  let erroreEsistente = false;
  var buonoCreato;
  do {
    erroreEsistente = false;
    const data = {
      prefisso: `${barcode.prefisso}${String(idCassa).padStart(2, "0")}`,
      ultimoNumero: barcode.ultimoNumero,
      tipo: barcode.tipoCodice,
      importo,
    };
    const response = await fetch(`${service}/create/buono`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    // La funzione restituisce errore se il buono da creare esiste già --> ciclo per creare il successivo, fino a quando non viene trovato
    buonoCreato = await response.json();
    if (buonoCreato.status === "error") {
      erroreEsistente = true;
      barcode.ultimoNumero = barcode.ultimoNumero + 1;
    }
  } while (erroreEsistente);
  await configurazioni.setBarcodeInfo(
    "buonomultiuso",
    "write",
    buonoCreato.ultimoNumero,
  );
  return buonoCreato;
}

async function aggiornaBuonoMultiuso(card) {
  // solo il contenuto di buono, non tutta la card ?!
  const response = await fetch(`${service}/${card._id}/update/buono`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(card.buono),
  });
  return await response.json();
}

async function cancellaBuono(idBuono) {
  const response = await fetch(`${service}/buono/${idBuono}/delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await response.json();
}

/* async function creaCouponOld(idCassa, importo, applicaA, spesaMinima) {
  var barcode = await configurazioni.getBarcodeInfo("coupon");
  const data = {
    prefisso: `${barcode.prefisso}${String(idCassa).padStart(2, "0")}`,
    ultimoNumero: barcode.ultimoNumero,
    tipo: barcode.tipoCodice,
    importo,
    applicaA,
    spesaMinima
  };
  const response = await fetch(`${service}/create/coupon`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  const couponCreato = await response.json();
  await configurazioni.setBarcodeInfo(
    "coupon",
    "write",
    couponCreato.ultimoNumero,
  );
  return couponCreato;
} */

async function creaCoupon(idCassa, importo, applicaA, spesaMinima) {
  var barcode = await configurazioni.getBarcodeInfo('coupon')
  let erroreEsistente = false
  var couponCreato
  do {
    erroreEsistente = false
    const data = {
      prefisso: `${barcode.prefisso}${String(idCassa).padStart(2, '0')}`,
      ultimoNumero: barcode.ultimoNumero,
      tipo: barcode.tipoCodice,
      importo,
      applicaA,
      spesaMinima
    }
    const response = await fetch(`${service}/create/coupon`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    couponCreato = await response.json()
    if (couponCreato.status === 'error') {
      erroreEsistente = true
      barcode.ultimoNumero = barcode.ultimoNumero + 1
    }
  } while (erroreEsistente)
  await configurazioni.setBarcodeInfo('coupon', 'write', couponCreato.ultimoNumero)
  return couponCreato
}

async function aggiornaCoupon(card) {
  // solo il contenuto di coupon, non tutta la card ?!
  const response = await fetch(`${service}/${card._id}/update/coupon`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(card.coupon),
  });
  return await response.json();
}

async function cancellaCoupon(idCoupon) {
  const response = await fetch(`${service}/coupon/${idCoupon}/delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await response.json();
}

async function creaBuonoMonouso(idCassa, importo) {
  var barcode = await configurazioni.getBarcodeInfo("buonomonouso");
  const data = {
    prefisso: `${barcode.prefisso}${String(idCassa).padStart(2, "0")}`,
    ultimoNumero: barcode.ultimoNumero,
    tipo: barcode.tipoCodice,
    importo,
  };
  const response = await fetch(`${service}/create/monouso`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  const buonoCreato = await response.json();
  await configurazioni.setBarcodeInfo(
    "buonomonouso",
    "write",
    buonoCreato.ultimoNumero,
  );
  return buonoCreato;
}

async function aggiornaBuonoMonouso(card) {
  // solo il contenuto di buono, non tutta la card ?!
  const response = await fetch(`${service}/${card._id}/update/monouso`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(card.buono),
  });
  return await response.json();
}

async function aggiornaPrepagata(card) {
  // solo il contenuto di buono, non tutta la card ?!
  const response = await fetch(`${service}/${card._id}/update/prepagata`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(card.buono),
  });
  return await response.json();
}


async function aggiornaAccesso(card) {
  const response = await fetch(`${service}/${card._id}/update/accesso`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(card)
  })
  return await response.json();
}

async function aggiornaRaccoltaPunti(card, scontrino) {
  const data = {
    scontrino,
  };
  const response = await fetch(`${service}/${card._id}/update/raccolta`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function infoRaccoltaPunti(cardId, importoPagato) {
  const data = {
    importoPagato,
  };
  const response = await fetch(`${service}/${cardId}/info/raccolta`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function annullamentoScontrino(scontrinoId, cardId, punti) {
  const data = {
    scontrinoId,
    punti,
  };
  const response = await fetch(`${service}/${cardId}/update/annullascontrino`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function aggiornaInfoAcquistoCard(
  codice,
  infoAcquisto,
  importo,
  scadenza,
  prepagata
) {
  var data = {
    infoAcquisto,
    importo,
    scadenza,
    prepagata
  };
  const response = await fetch(`${service}/${codice}/update/acquisto`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function creaFidelityCard(idCassa) {
  var barcode = await configurazioni.getBarcodeInfo("fidelitycard");
  let erroreEsistente = false
  var fidelityCreata
  do {
    erroreEsistente = false
    const data = {
      prefisso: `${barcode.prefisso}${String(idCassa).padStart(2, '0')}`,
      ultimoNumero: barcode.ultimoNumero,
      tipo: barcode.tipoCodice
    }
    const response = await fetch(`${service}/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    fidelityCreata = await response.json()
    if (fidelityCreata.status === 'error') {
      erroreEsistente = true
      barcode.ultimoNumero = barcode.ultimoNumero + 1
    }
  } while (erroreEsistente)
  await configurazioni.setBarcodeInfo(
    "fidelitycard",
    "write",
    fidelityCreata.ultimoNumero,
  );
  return fidelityCreata.card;
}

async function creaFidelityCardEsterna(codice, payload) {
  const data = {
    codice,
    payload,
  };
  const response = await fetch(`${service}/create/extern`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  const fidelityCreata = await response.json();
  return fidelityCreata;
}

async function creaFidelityCardCliente(idCassa, dati, cliente) {
  var barcode = await configurazioni.getBarcodeInfo("fidelitycard");
  let erroreEsistente = false
  var fidelityCreata
  do {
    erroreEsistente = false
    const data = {
      prefisso: `${barcode.prefisso}${String(idCassa).padStart(2, '0')}`,
      ultimoNumero: barcode.ultimoNumero,
      tipo: barcode.tipoCodice,
      dati: dati,
      cliente: cliente
    }
    const response = await fetch(`${service}/create/customer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    fidelityCreata = await response.json()
    if (fidelityCreata.status === 'error') {
      erroreEsistente = true
      barcode.ultimoNumero = barcode.ultimoNumero + 1
    }
  } while (erroreEsistente)
  await configurazioni.setBarcodeInfo(
    "fidelitycard",
    "write",
    fidelityCreata.ultimoNumero,
  );
  return fidelityCreata.card;
}

async function aggiornaFidelity(codiceFidelity, dati) {
  const response = await fetch(`${service}/${codiceFidelity}/update`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(dati),
  });
  return await response.json();
}

async function associaFidelity(codiceFidelity, codiceCliente, ragioneSociale) {
  var data = {
    codice: codiceCliente,
    ragioneSociale,
  };
  const response = await fetch(`${service}/${codiceFidelity}/update/associa`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function deleteFidelity(code, utente, operatore) {
  // inserisce il record di annullamento
  var data = {
    code,
    utente,
    operatore,
  };
  const response = await fetch(`${service}/delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function creaCardAccessiCliente(dati, cliente) {
  var barcode = await configurazioni.getBarcodeInfo("accesso");
  let erroreEsistente = false
  var cardCreata
  do {
    erroreEsistente = false
    const data = {
      prefisso: barcode.prefisso,
      ultimoNumero: barcode.ultimoNumero,
      tipo: barcode.tipoCodice,
      dati: dati,
      cliente: cliente
    }
    const response = await fetch(`${service}/fidelity/create/customer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    cardCreata = await response.json()
    if (cardCreata.status === 'error') {
      erroreEsistente = true
      barcode.ultimoNumero = barcode.ultimoNumero + 1
    }
  } while (erroreEsistente)
  await configurazioni.setBarcodeInfo(
    "accesso",
    "write",
    cardCreata.ultimoNumero,
  );
  return cardCreata.card;
}

async function cercaFidelityByCode(
  code,
  len,
  associata = true,
  type = "multiuso",
) {
  const response = await fetch(
    `${service}/search?code=${code}&len=${len}&associata=${associata}&type=${type}`,
  );
  return await response.json();
}

async function cercaFidelityById(id, len, associata = true, type = "multiuso") {
  const response = await fetch(
    `${service}/search?id=${id}&len=${len}&associata=${associata}&type=${type}`,
  );
  return await response.json();
}

async function cercaFidelityByTicket(
  ticket,
  len,
  associata = true,
  type = "multiuso",
) {
  const response = await fetch(
    `${service}/search?ticket=${ticket}&len=${len}&associata=${associata}&type=${type}`,
  );
  return await response.json();
}

async function cercaFidelityByPurchaseTicket(
  ticket,
  len,
  associata = true,
  type = "multiuso",
) {
  const response = await fetch(
    `${service}/search?purchase=${ticket}&len=${len}&associata=${associata}&type=${type}`,
  );
  return await response.json();
}

async function cercaFidelityByCliente(type = "multiuso", codiceCliente) {
  const response = await fetch(
    `${service}/search?customer=${codiceCliente}&type=${type}`,
  );
  return await response.json();
}

async function elencoFidelityPerData(dataDa, dataA, type = "multiuso") {
  const data = {
    tipo: type,
    dataDa,
    dataA,
  };
  const response = await fetch(`${service}/data`, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify(data),
  });
  return await response.json();
}

// **********************************************************************************************************************
// *******************************   EVENTI    **************************************************************************
// **********************************************************************************************************************

async function verificaEvento(ctx, evento) {
  const data = {
    evento,
    importoScontrino: parseFloat(ctx.totaleScontrino).toFixed(2)
  };
  const card = ctx.fidelityCard;
  const response = await fetch(`${service}/${card._id}/evento`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return await response.json()
}

// TODO: Verificare se cambiare nome
async function riscattaBuono(cardId, codiceBuono, spesaEffettuata, richiestaStampa, infoRiscatto) {
  console.log('sto chiamadn', service)
  const data = {
    cardId,
    codiceBuono,
    spesaEffettuata,
    richiestaStampa,
    infoRiscatto
  }
  const response = await fetch(`${service}/riscatta/buono`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return await response.json()
}

export default {
  cicleSync,
  getRunMode,
  getFidelity,
  creaBuonoMultiuso,
  aggiornaBuonoMultiuso,
  aggiornaInfoAcquistoCard,
  creaFidelityCard,
  creaFidelityCardEsterna,
  creaFidelityCardCliente,
  aggiornaFidelity,
  aggiornaPrepagata,
  aggiornaAccesso,
  aggiornaRaccoltaPunti,
  infoRaccoltaPunti,
  annullamentoScontrino,
  associaFidelity,
  deleteFidelity,
  creaCardAccessiCliente,
  cercaFidelityByCode,
  cercaFidelityById,
  cercaFidelityByTicket,
  cercaFidelityByPurchaseTicket,
  cercaFidelityByCliente,
  creaBuonoMonouso,
  aggiornaBuonoMonouso,
  elencoFidelityPerData,
  cancellaBuono,
  creaCoupon,
  aggiornaCoupon,
  cancellaCoupon,
  verificaEvento,
  riscattaBuono
};
